import { UserRole } from '../services/api.services';

export enum SupportLinkDisplay {
  Link = 'link',
  Button = 'button',
  Dialog = 'dialog'
};

export interface SupportLinkContent {
  display: SupportLinkDisplay;
  title: string;
  description: string;
  hidden: boolean;
  url: string;
  target?: string;
  icon?: string;
  role?: UserRole;
};

export interface SupportLinksContent {
  links: SupportLinkContent[];
};

export const SupportLinksDefaultContent: SupportLinksContent = {
  links: [
    {
      display: SupportLinkDisplay.Link,
      title: 'Knowledge Base',
      description: 'Optimize Insights Knowledge Base articles',
      hidden: false,
      url: 'https://support.trgscreen.com/s/',
      target: '_blank',
      icon: null,
      role: UserRole.InsightsUser,
    },
    {
      display: SupportLinkDisplay.Link,
      title: 'Support',
      description: 'Optimize Insights Support Services',
      hidden: false,
      url: 'https://support.trgscreen.com/s/contactsupport',
      target: '_blank',
      icon: null,
      role: UserRole.InsightsUser,
    },
    {
      display: SupportLinkDisplay.Link,
      title: 'Release Notes',
      description: 'Optimize Insights Release Notes',
      hidden: true,
      url: '',
      target: '_self',
      icon: null,
      role: UserRole.InsightsUser,
    },
    {
      display: SupportLinkDisplay.Dialog,
      title: 'Data Health Status',
      description: 'Historical log of system data health',
      hidden: true,
      url: '',
      target: '_blank',
      icon: null,
      role: UserRole.ClientUser,
    },
    {
      display: SupportLinkDisplay.Dialog,
      title: 'System',
      description: 'Licensing and System Information',
      hidden: true,
      url: '',
      target: '_self',
      icon: null,
      role: UserRole.ClientUser,
    },
    {
      display: SupportLinkDisplay.Link,
      title: 'Privacy Statement',
      description: null,
      hidden: false,
      url: 'https://www.trgscreen.com/privacy-policy',
      target: '_blank',
      icon: 'far fa-external-link',
      role: UserRole.ClientUser,
    }
  ]
};
